import { ArrowUpRight } from 'lucide-react';
import { useLanguageContext } from '../context/languageContext';
import { affiliateUrl, cars } from './CarRentalFloat';
import LivePrices from './LivePrices';

export default function CarRentalBanner() {
  const { language } = useLanguageContext();
  const copy = language === 'sq' ? {
    title: 'Zbuloni Shqipërinë me makinë', description: 'Krahasoni makina me qira me DiscoverCars dhe gjeni ofertën për udhëtimin tuaj.',
    action: 'Shikoni makinat', disclosure: 'Lidhje affiliate: mund të marrim komision nga rezervimet.',
  } : language?.toLowerCase() === 'it' ? {
    title: 'Esplora l’Albania in auto', description: 'Confronta le auto a noleggio con DiscoverCars e trova un’offerta per il tuo viaggio.',
    action: 'Scopri le auto', disclosure: 'Link affiliato: potremmo ricevere una commissione sulle prenotazioni.',
  } : {
    title: 'Explore Albania by car', description: 'Compare rentals with DiscoverCars and find a car for your next adventure.',
    action: 'Compare car rentals', disclosure: 'Affiliate link: we may earn a commission on bookings.',
  };
  return <section id="car-rentals" aria-labelledby="car-rentals-title" className="bg-cream px-4 py-4">
    <div className="mx-auto max-w-5xl overflow-hidden rounded-3xl border border-blue-100 bg-blue-50 p-5 sm:p-8">
      <div className="grid items-center gap-5 sm:grid-cols-2">
        <div>
          <img src="/discovercars-logo.svg" alt="DiscoverCars" width="176" height="32" className="h-8 w-44 object-contain object-left" />
          <h2 id="car-rentals-title" className="mt-2 text-2xl font-bold leading-tight text-slate-900 sm:text-3xl">{copy.title}</h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">{copy.description}</p>
          <a href={affiliateUrl} target="_blank" rel="sponsored noopener noreferrer" className="mt-5 flex min-h-[48px] items-center justify-between gap-3 rounded-xl bg-blue-700 px-4 py-3 text-sm font-bold text-white hover:bg-blue-800 sm:inline-flex">{copy.action}<ArrowUpRight aria-hidden="true" className="h-5 w-5" /></a>
        </div>
        <a href={affiliateUrl} target="_blank" rel="sponsored noopener noreferrer" aria-label={copy.action} className="grid grid-cols-3 items-end gap-2 rounded-2xl bg-white p-3">
          {cars.map(car => <div key={car.name} className="min-w-0 text-center">
            <img src={car.image} alt={car.name} loading="lazy" width="300" height="160" className="h-20 w-full object-contain sm:h-28" />
            <p className="mt-2 text-xs font-semibold text-slate-700">{car.name}</p>
          </div>)}
        </a>
      </div>
      <LivePrices provider="cars" />
      <p className="mt-4 text-xs leading-relaxed text-slate-500">{copy.disclosure}</p>
    </div>
  </section>;
}
